import React from "react";

const LegalLaw = () => (
  <section className="w-full bg-white py-8 px-6">
    <h2 className="text-xl font-bold text-dark-1 mb-4">7. Loi applicable</h2>
    <p className="text-light-1">
      Les présentes mentions légales sont régies par la loi en vigueur dans le pays où est domiciliée la structure éditrice 
      (<em>ex. République du Bénin</em>).
    </p>
  </section>
);

export default LegalLaw;
